(function ($) {
    var validateAF = $('#apply form.wpcf7-form');
    var validator = validateAF.validate(window.myStore.validatorOptions);
    $('#apply form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateAF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });
    $('#apply form.wpcf7-form input[type=tel]').mask('000-000-0000');
    $('#apply form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder","222-222-2222");
    });
    $('#apply form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder","");
    });
    $('#apply form.wpcf7-form input[name=firstname]').mask( 'N', window.myStore.custom_validation );
    $('#apply form.wpcf7-form input[name=company]').mask( 'C', window.myStore.custom_validation );
    $('#apply form.wpcf7-form input[name=email]').mask( 'M', window.myStore.custom_validation );

})(jQuery);